module.exports = __webpack_public_path__ + "assets/img/distributor.e377c8ef.svg";